// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
// utils
import { fToNow } from 'src/utils/format-time';
// components

import { Notification } from 'src/types/user';
import { paths } from 'src/routes/paths';
import * as React from "react";
import {useRouter} from "../../../routes/hooks";
import {getServerName} from "../../../utils/serverName";

// ----------------------------------------------------------------------

type NotificationItemProps = {
  notification: Notification
};

export default function NotificationItem({ notification }: NotificationItemProps) {
  const router = useRouter();
  const renderAvatar =
    (
    <ListItemAvatar>
      {/* {notification.avatarUrl ? ( */}
      {/*  <Avatar src={notification.avatarUrl} sx={{ bgcolor: 'background.neutral' }} /> */}
      {/* ) : ( */}
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: 'background.default',
          }}
        >
          <Box
            component="img"
            src={`/assets/icons/notification/${
              (notification.type === 'register' && 'ic_avatar')
              || (notification.type === 'androidApp' && 'ic_avatar')
              || 'ic_mail'
            }.svg`}
          />
        </Stack>
      {/* )} */}
    </ListItemAvatar>
  );

  const renderText = (
    <ListItemText
      disableTypography
      primary={reader(messageFromNotification(notification))}
      secondary={
        <Stack
          direction="row"
          alignItems="center"
          sx={{ typography: 'caption', color: 'text.disabled' }}
          divider={
            <Box
              sx={{
                width: 2,
                height: 2,
                bgcolor: 'currentColor',
                mx: 0.5,
                borderRadius: '50%',
              }}
            />
          }
        >
          {fToNow(notification.createdAt)}
          {(notification.type === 'register' && 'Регистрация')
            || (notification.type === 'androidApp' && 'Приложение')
            || 'Съобщения'}
        </Stack>
      }
    />
  );

  const renderUnReadBadge = (
    <Box
      sx={{
        top: 26,
        width: 8,
        height: 8,
        right: 20,
        borderRadius: '50%',
        bgcolor: 'info.landing',
        position: 'absolute',
      }}
    />
  );

  const registerAction = (
    <Stack spacing={1} direction="row" sx={{ mt: 1.5 }}>
      <Button size="small" variant="contained" onClick={() => {router.push(paths.auth.jwt.register)}}>
        Регистрирай се
      </Button>
    </Stack>
  );

  const androidAppIcon = (
      <a href='https://play.google.com/store/apps/details?id=io.ionic.matematico&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img width={150} alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
  )

  const systemMessageChat = (
    <Stack spacing={1} direction="row" sx={{ mt: 1.5 }}>
      <Button size="small" variant="contained" onClick={() => {router.push(paths.contacts.chat)}}>
        Към чата
      </Button>
    </Stack>
  )

  return (
    <ListItemButton
      disableRipple
      sx={{
        p: 2.5,
        alignItems: 'flex-start',
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
      }}
    >
      {renderUnReadBadge}

      {renderAvatar}

      <Stack sx={{ flexGrow: 1 }}>
        {renderText}
        {notification.type === 'register' && registerAction}
        {notification.type === 'androidApp' && androidAppIcon}
        {notification.type === 'unreadMessage' && systemMessageChat}
      </Stack>
    </ListItemButton>
  );
}

// ----------------------------------------------------------------------

function reader(data: string) {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: data }}
      sx={{
        mb: 0.5,
        '& p': { typography: 'body2', m: 0 },
        '& a': { color: 'inherit', textDecoration: 'none' },
        '& strong': { typography: 'subtitle2' },
      }}
    />
  );
}

function messageFromNotification(notif: Notification): string {
  if(notif.type === 'register') {
    return 'Ти си с гост акаунт. <br/>Регистрирай се, за да защитиш прогреса си с мейл и парола.';
  }
  if(notif.type === 'androidApp') {
    return 'Изтегли си приложението за Android, за да получиш по-лесен и удобен достъп.';
  }
  if(notif.type === 'unreadMessage') {
    return `Имаш ново съобщение от създателите на ${getServerName()}.`;
  }
  return '';
}
